'use client';
import { FC, useState } from 'react';
import { useSession } from 'next-auth/react';
import { ChevronRight } from '@eqi-investimentos/icons/web';
import { Button, Flex, Text } from '@eqi-investimentos/react';
import { useT } from '@/libs/i18n/utils/useT';
import { WidgetContainer } from '@/components/modules/Widget/Container';
import { IfRender } from '@/utils/jsx';
import { useGetPastEvents } from '../../http/client/useGetListPastsEvents';
import { CardEvent } from '../CardEvent/CardEvent';
import { ModalSendSuggestion } from '../ModalSendSuggestion/ModalSendSuggestion';
import { NoDataEventsWidget } from '../NoDataEventsWidget/NoDataEventsWidget';
import { SkeletonWidgetListSlide } from '../SkeletonWidgetListSlide/SkeletonWidgetListSlide';

export const PastEvents: FC = () => {
  const t = useT();
  const { data: session } = useSession();

  const [showModalSuggestion, setShowModalSuggestion] = useState(false);

  const { data: events = [], isFetching } = useGetPastEvents();

  if (isFetching) {
    return (
      <SkeletonWidgetListSlide title={t(`screens.events.titleWidgets.prev`)} />
    );
  }

  const handleSendSuggestion = () => {
    if (!session || !session.access_token) {
      window.dispatchEvent(new Event('open-unauthenticated-modal'));
      return;
    }

    setShowModalSuggestion(true);
  };

  return (
    <>
      <ModalSendSuggestion
        t={t}
        isOpen={showModalSuggestion}
        onClose={() => setShowModalSuggestion(false)}
      />

      <IfRender condition={events.length === 0 && !isFetching}>
        <NoDataEventsWidget
          isPast
          handleSendSuggestion={() => setShowModalSuggestion(true)}
        />
      </IfRender>
      <IfRender condition={events.length > 0 && !isFetching}>
        <WidgetContainer
          containerId={`event-list-widget-prev`}
          showTitles={false}
          removeSeeAllButton
          containerTitleProps={{ h: '3.75rem' }}
          sliderProps={{ swiperGap: `45px` }}
          customTitle={
            <Flex flexDir="column" alignItems="start" gap="2xs" mb="xl">
              <Text size="h6" fontWeight="normal">
                {t(`screens.events.titleWidgets.prev`)}
              </Text>
              <Button
                variant="naked"
                justifyContent="center"
                alignItems="center"
                w="auto"
                h="auto"
                p="0"
                gap="xs"
                _hover={{ bg: 'transparent' }}
                onClick={handleSendSuggestion}
                rightIcon={
                  <ChevronRight width={24} height={24} color="content.brand" />
                }
              >
                <Text size="l" fontWeight="normal" color="content.brand">
                  {t(`screens.events.suggestedTheme`)}
                </Text>
              </Button>
            </Flex>
          }
        >
          {events.map((event, idx) => (
            <CardEvent key={idx} event={event} isPast />
          ))}
        </WidgetContainer>
      </IfRender>
    </>
  );
};
